"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import Logo from "./Logo";

const NAV_LINKS = [
  { label: "Integrations", href: "/#integrations" },
  { label: "Use cases", href: "/#use-cases" },
  { label: "Pricing", href: "/pricing" },
  { label: "Resources", href: "/blog" },
  { label: "Documentation", href: "https://docs.growthrail.dev" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={`fixed inset-x-0 z-50 transition-all duration-300 flex justify-center ${scrolled ? "top-2 px-4" : "top-0 px-0"}`}>
      <header
        className={`w-full transition-all duration-300 ${
          scrolled
            ? "max-w-5xl rounded-2xl border border-white/10 bg-black/70 backdrop-blur-xl shadow-2xl overflow-hidden"
            : open
              ? "max-w-7xl border-b border-white/10 bg-black/90 backdrop-blur-xl"
              : "max-w-7xl border-b border-transparent bg-transparent"
        }`}
      >
        <div className="mx-auto flex h-16 items-center justify-between px-5 sm:px-6 lg:px-8">
        <Link href="/" className="flex shrink-0 items-center" aria-label="GrowthRail home">
          <Logo />
        </Link>



        <div className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="rounded-lg px-2.5 py-2 text-sm font-medium text-zinc-300 transition-colors hover:bg-white/5 hover:text-white"
            >
              {link.label}
            </Link>
          ))}
          <Link
            href="https://app.growthrail.dev/auth"
            className="rounded-lg px-3 py-2 text-sm font-medium text-zinc-300 transition-colors hover:bg-white/5 hover:text-white"
          >
            Sign in
          </Link>
          <Link
            href="https://app.growthrail.dev/auth"
            className="group relative inline-flex items-center gap-1.5 overflow-hidden rounded-lg border border-copper-300/30 bg-gradient-to-b from-copper-400 to-copper-600 px-4 py-2 text-sm font-medium text-white shadow-[0_0_20px_rgba(184,115,51,0.25)] transition-all hover:from-copper-300 hover:to-copper-500"
          >
            <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/25 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
            Start for free
            <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M5 10h10m0 0l-4-4m4 4l-4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-zinc-300 lg:hidden"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="mobile-navigation"
        >
          {open ? (
            <svg className="h-4 w-4" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 5l10 10M15 5L5 15" strokeLinecap="round" />
            </svg>
          ) : (
            <svg className="h-4 w-4" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 6h14M3 10h14M3 14h14" strokeLinecap="round" />
            </svg>
          )}
        </button>
      </div>

      {open && (
        <div id="mobile-navigation" className="border-t border-white/5 bg-black/95 backdrop-blur-xl lg:hidden">
          <div className="flex flex-col gap-1 px-5 py-4">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="flex min-h-12 items-center rounded-lg px-3 py-3 text-base font-medium text-zinc-300 hover:bg-white/5 hover:text-white"
              >
                {link.label}
              </Link>
            ))}
            <div className="mt-2 flex flex-col gap-2 border-t border-white/5 pt-3">
              <Link
                href="https://app.growthrail.dev/auth"
                onClick={() => setOpen(false)}
                className="flex min-h-12 items-center rounded-lg px-3 py-3 text-base font-medium text-zinc-300 hover:text-white"
              >
                Sign in
              </Link>
              <Link
                href="https://app.growthrail.dev/auth"
                onClick={() => setOpen(false)}
                className="flex min-h-12 items-center justify-center rounded-lg border border-copper-300/30 bg-gradient-to-b from-copper-400 to-copper-600 px-4 py-3 text-center text-base font-medium text-white"
              >
                Start for free
              </Link>
            </div>
          </div>
        </div>
      )}
      </header>
    </div>
  );
}
